import {
  Action,
  ThunkDispatch,
  TypedAddListener,
  TypedRemoveListener,
  addListener,
  removeListener
} from '@reduxjs/toolkit'
import { RootState } from '@dtx-company/inter-app/src/redux/types'

/**
 * An action that can be dispatched to dynamically add listener middleware to the store at runtime.
 * Typed version of the original `addListener` function.
 *
 * @see https://redux-toolkit.js.org/api/createListenerMiddleware#typescript-usage
 */
export const addFlowListener = addListener as TypedAddListener<
  RootState,
  ThunkDispatch<RootState, unknown, Action>
>

/**
 * An action that can be dispatched to dynamically remove listener middleware to the store at runtime.
 * Typed version of the original `removeListener` function.
 *
 * @see https://redux-toolkit.js.org/api/createListenerMiddleware#typescript-usage
 */
export const removeFlowListener = removeListener as TypedRemoveListener<
  RootState,
  ThunkDispatch<RootState, unknown, Action>
>
